
import { defineComponent, onMounted, ref } from "vue";
import { getAdvisoryDetails, getBankAccountNo, getAwardingDetails_API, isShowPaymentMisuseAdvisory, isShowPearlHungDownlineAdvisory } from "@/api/dashboard";
import { ecShopAdvisoryVisibility } from "@/api/common";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import SeqNoticeCard from "@/components/dashboard/sequence/SeqNoticeCard.vue";


export default defineComponent({
  name: "ecshopadvisory",
  components: {
    SeqNoticeCard
  },
  data() {
    return { 
      pt : "",
      isEnabledECCSRNotification : false,
      csrMessage : "",
      ccode : -1,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      nigeriaAIMGLOBAL_HQ_WARNING_ImgUrl : "",
      bankAccountNo : "",
      isShowBDOMastercardAdvisory : false,
      isDMPayView : false,
      ecShopAdvisoryVisibility,
      isShowHoodiePage : false,
      awarding_details : {},
      isShowPaymentMisuseAdvisory_Var : false,
      showPaymentMisuseAdvisoryInKinyarwanda : false,
      isShowPearlHungDownlineAdvisory_Var : false,
    }
  },
  mounted(){
    this.pt = String(localStorage.getItem("pt"));
    this.getDashboardECPWelcomeData();
    this.getAwardingDetails();
    this.isShowPaymentMisuseAdvisory_FN();
    this.isShowPearlHungDownlineAdvisory_FN();
    //this.getUserCcode();
    //this.getBankAccountNumber();
    this.checkIfDMPayView();
    this.onResize();
    this.ccode = Number(localStorage.getItem("ccode"));

    let currLocation = String(window.location).split("/#/");
    let currView = "";
    if(currLocation.length > 1){
      currView = currLocation[1];
    }
    this.ecShopAdvisoryVisibility = ecShopAdvisoryVisibility;


  },
  methods : {
    async getDashboardECPWelcomeData(){
      const response = await getAdvisoryDetails();

      this.isEnabledECCSRNotification = response.data.isEnabledECCSRNotification;
      this.csrMessage = response.data.orderid;
      this.isShowBDOMastercardAdvisory = response.data.isShowBDOMastercardAdvisory;
      this.isShowHoodiePage = response.data.isShowHoodiePage;
    },
    async getUserCcode() {
      this.ccode = Number(localStorage.getItem("ccode"));
    },
    async checkIfDMPayView(){
      this.ccode = Number(localStorage.getItem("isDMPayView"));
    },
    async getBankAccountNumber() {
      const response = await getBankAccountNo();
        if(response.data !== undefined ) {
          this.bankAccountNo = response.data.bankAccountNo;
        }
    },

    async getAwardingDetails() {
      const response = await getAwardingDetails_API();
      if(response.data.awarding_barcode[0] !== undefined ) {
        this.awarding_details = response.data.awarding_barcode[0];
      }
    },
    async isShowPaymentMisuseAdvisory_FN(){
      try {
        const response = await isShowPaymentMisuseAdvisory();
        this.isShowPaymentMisuseAdvisory_Var = !!(response && response.data && response.data.isShowAllegedPaymentMisuse_Advisory);
      } catch (e) {
        this.isShowPaymentMisuseAdvisory_Var = false;
      }
    },
    async isShowPearlHungDownlineAdvisory_FN(){
      try {
        const response = await isShowPearlHungDownlineAdvisory();
        this.isShowPearlHungDownlineAdvisory_Var = !!(response && response.data && response.data.isShowPearlHungDownlineAdvisory);
        if (this.isShowPearlHungDownlineAdvisory_Var) {
          const isMobile = window.innerWidth <= 768;
          const imageHeight = Math.min(600, Math.max(220, window.innerHeight - 180));

          Swal.fire({
            imageUrl: "https://images.empoweredconsumerism-static-files.com/ecp/PEARL_HUNG_DOWNLINE_ADVISORY.jpg",
            imageHeight: imageHeight,
            imageAlt: "Pearl Hung Downline Advisory",
            showConfirmButton: true,
            confirmButtonText: "Close",
            width: isMobile ? Math.min(window.innerWidth - 24, 360) : "auto",
            heightAuto: true,
            scrollbarPadding: false,
            didOpen: () => {
              const popup = Swal.getPopup();
              const image = Swal.getImage();
              const actions = Swal.getActions();
              if (popup) {
                popup.style.maxHeight = "90vh";
                popup.style.display = "flex";
                popup.style.flexDirection = "column";
                popup.style.overflow = "hidden";
              }
              if (image) {
                image.style.maxHeight = `${Math.max(180, window.innerHeight - 180)}px`;
                image.style.width = "auto";
                image.style.maxWidth = "100%";
                image.style.objectFit = "contain";
                image.style.flex = "1 1 auto";
                image.style.minHeight = "0";
              }
              if (actions) {
                actions.style.flex = "0 0 auto";
                actions.style.marginTop = "0.75rem";
                actions.style.position = "sticky";
                actions.style.bottom = "0";
                actions.style.background = "#fff";
                actions.style.zIndex = "2";
              }
            },
          });
        }
      } catch (e) {
        this.isShowPearlHungDownlineAdvisory_Var = false;
      }
    },
    togglePaymentMisuseAdvisoryLang() {
      this.showPaymentMisuseAdvisoryInKinyarwanda = !this.showPaymentMisuseAdvisoryInKinyarwanda;
    },
    onResize() {
      //this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= 450){
        this.nigeriaAIMGLOBAL_HQ_WARNING_ImgUrl = "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_MOBILE.jpg";
      } else {
        this.nigeriaAIMGLOBAL_HQ_WARNING_ImgUrl = "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_PC.jpg";
      }
    }
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
    });
    
  }
});
